import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../I18n';
import {Checkbox} from 'rctui';

class Mask extends React.Component {
  static defaultProps = {
    disabled: false,
    available: null,
    options: [],
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(value, dummy, checked) {
    let currentValue;
    if (value === Constants.Diff) {
      currentValue = checked ? Constants.Diff : 0;
    } else {
      let itemValue = parseInt(value, 10);
      currentValue = parseInt(this.props.value, 10);

      if (checked && !this.hasMask(itemValue) || !checked && this.hasMask(itemValue)) {
        currentValue ^= itemValue;
      }
    }

    this.props.onChange(this.props.name, currentValue);
  }

  hasMask(value) {
    return this.props.value == value || (this.props.value & value) === value;
  }

  isAvailable(value) {
    return (this.props.available == null || (this.props.available & value) === value);
  }

  render() {
    let options = this.props.options;

    if (this.props.value === Constants.Diff) {
      options = [{value: Constants.Diff, label: Constants.Diff}].concat(options);
    }

    let optionNodes = options.map((option, key) => {
      let checked = this.hasMask(option.value);

      return <label key={key}>
        <Checkbox
          onChange={this.onChange.bind(this, option.value)}
          checked={checked}
          readOnly={(option.value !== Constants.Diff && this.props.value === Constants.Diff) || !this.isAvailable(option.value)}>
          <I18n message={option.label}/>
        </Checkbox>
      </label>;
    });

    return (
      <div className={"block-checkbox dark-block-checkbox"}>
        {optionNodes}
      </div>
    );
  }
}

export default Mask;



// WEBPACK FOOTER //
// ./src/js/Component/Form/Mask.jsx